/* ============================
 * スムーズスクロール
 * ============================ */

import SmoothScroll from 'smooth-scroll';

const scroll = new SmoothScroll('a[href*="#"]', {
	speedAsDuration: true,
	speed: 1300,
	// offset: 70, // 停止位置
	// easing:'easeInOutQuint' // イージングも使えるよ！
});
